import Vue from 'vue';  
export default new Vue(); 


//////////////////
// WEBPACK FOOTER
// ./eventBus/eventBus.js
// module id = 158
// module chunks = 1 2